import * as yup from 'yup';
import { PortalUserRole } from '../..';
export const manageUserSchema = yup
    .object({
    userId: yup.string().required(),
    updatedUserId: yup.string().optional(),
    isActive: yup.boolean().optional(),
    isDeleted: yup.boolean().optional(),
    role: yup.mixed().oneOf(Object.values(PortalUserRole)).required(),
    permissions: yup.number().optional(),
    merchantAccounts: yup.lazy((value) => yup
        .object(Object.keys(value || {}).reduce((acc, key) => {
        acc[key] = yup.boolean();
        return acc;
    }, {}))
        .required()),
    merchantGroupIds: yup.array().of(yup.string().defined()).required(),
    email: yup.string().email().optional(),
    phone: yup.string().optional(),
    locale: yup.string().optional(),
    countryCode: yup.string().optional(),
    firstName: yup.string().optional(),
    lastName: yup.string().optional(),
})
    .required();
export const updateUserSchema = yup
    .object({
    email: yup.string().email().optional(),
    phone: yup.string().optional(),
    locale: yup.string().optional(),
    countryCode: yup.string().optional(),
    firstName: yup.string().optional(),
    lastName: yup.string().optional(),
})
    .required();
export const accessRequest = yup.object({
    email: yup.string().email().required(),
    phone: yup.string().required(),
    locale: yup.string().required(),
    countryCode: yup.string().required(),
    firstName: yup.string().required(),
    lastName: yup.string().required(),
});
export const importUsersSchema = yup.array().of(yup.object({
    appliedIdentityId: yup.string().required(),
    email: yup.string().required(),
    firstName: yup.string().required(),
    lastName: yup.string().required(),
    merchantAccountHolderCodes: yup.array().of(yup.string()),
    merchantGroupIds: yup.array().of(yup.string()),
}));
//# sourceMappingURL=portalUser.js.map